import { forwardRef } from "react";
import { NavLink as RouterLink } from "react-router-dom";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";

const NavLink = forwardRef((props, ref) => <RouterLink ref={ref} {...props} />);

function MenuItem(props) {
    const { icon = <SettingsIcon />, text, to, ...restProps } = props;

    return (
        <ListItemButton
            component={NavLink}
            to={to}
            sx={{
                "&.active": {
                    color: "rgb(24, 144, 255)",
                    backgroundColor: "rgb(230, 247, 255)",
                },
            }}
            {...restProps}
        >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={text} />
        </ListItemButton>
    );
}

export default MenuItem;
